import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconType = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--type")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M9,21 C8.44771525,21 8,20.5522847 8,20 C8,19.4477153 8.44771525,19 9,19 L9,19 L11,19 L11,5 L5,5 L5,7 C5,7.55228475 4.55228475,8 4,8 C3.44771525,8 3,7.55228475 3,7 L3,7 L3,4 C3,3.44771525 3.44771525,3 4,3 L4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,4 L21,7 C21,7.55228475 20.5522847,8 20,8 C19.4477153,8 19,7.55228475 19,7 L19,7 L19,5 L13,5 L13,19 L15,19 C15.5128358,19 15.9355072,19.3860402 15.9932723,19.8833789 L16,20 C16,20.5522847 15.5522847,21 15,21 L15,21 Z" id="icon--centivo--type"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-480.000000, -1312.000000)"/>
          <g id="Icon/type">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--type"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--type"/>
          </g>
      </g>
  </IconWrapper>
)
